import { render } from "./InternalError.vue?vue&type=template&id=5255143c"
import script from "./InternalError.vue?vue&type=script&lang=js"
export * from "./InternalError.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__